import React from 'react'
import { Icon } from '@iconify/react';
import Div from '../Div';

export default function SocialWidget() {
  return (
    <Div className="cs-social_btns cs-style1">
      <a href='https://www.linkedin.com/company/codewus' target='_blank' rel='noreferrer' className="cs-center">
        <Icon icon="fa6-brands:linkedin-in" />
      </a>
      <a href='https://wa.me/971544905157' target='_blank' rel='noreferrer' className="cs-center">
        <Icon icon="fa6-brands:whatsapp" />               
      </a>
      <a href='https://github.com/eldarovm' target='_blank' rel='noreferrer' className="cs-center">
        <Icon icon="fa6-brands:github" />              
      </a>
      <a href='mailto:info@codewus.ae' className="cs-center">
        <Icon icon="mdi:envelope" />
      </a>
    </Div>
  )
}
